module.exports = __webpack_public_path__ + "img/user-group2_in.53ec58e8.png";